import { ReactNode } from 'react'

type PageHeadingProps = {
    title: string
    subtitle?: string
}

type PageProps = {
    title?: string
    subtitle?: string
    children: ReactNode
    className?: string
}
export default function Page({ title, subtitle, children, className }: PageProps) {
    return (
        <div className={`flex flex-1 flex-col gap-4 px-6 ${className}`}>
            {(title || subtitle) && <PageHeading title={title || ''} subtitle={subtitle} />}
            {children}
        </div>
    )
}

const PageHeading = ({ title, subtitle }: PageHeadingProps) => {
    return (
        <div className="my-6 flex flex-col gap-1 pl-1">
            <div className="flex items-center gap-2">
                <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
            </div>
            {subtitle && <p className="text-muted-foreground text-base">{subtitle}</p>}
        </div>
    )
}
